export const RADIO_ERROR_ID = {
    studentMaritalStatus: 'student-marital-single',
    studentHasDependents: 'student-dependents-yes',
    studentIncomeEarnedBy: 'student-income-neither',
    parentMaritalStatus: 'parent-marital-single',
    parentHasDependents: 'parent-dependents-yes',
    parentIncomeEarnedBy: 'parent-income-neither'
};